import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../components/Loading";
import { apiUrl } from "../lib/api";

export default function Processing() {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const statusUrl = useMemo(() => apiUrl(`/jobs/${jobId}`), [jobId]);

  useEffect(() => {
    if (!jobId) return;
    let cancelled = false;
    let timer = null;

    const tick = async () => {
      try {
        const res = await fetch(statusUrl);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (cancelled) return;

        if (data.status === "done" && data.result) {
          navigate("/result", { state: { result: data.result,job_id: jobId, } });
          return;
        }
        if (data.status === "failed") {
          setError(data.error || "Job failed.");
          return;
        }
        timer = setTimeout(tick, 2000);
      } catch (e) {
        if (cancelled) return;
        setError(e?.message ? String(e.message) : "Failed to fetch job status.");
      }
    };

    tick();
    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
  }, [jobId, navigate, statusUrl]);

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="text-center bg-white p-10 rounded-lg shadow border border-gray-200 max-w-xl">
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">
            Failed to process genome
          </h2>
          <p className="text-gray-600 break-words">{error}</p>
          <button
            onClick={() => navigate("/search")}
            className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-white bg-blue-700 hover:bg-blue-800 px-4 py-2 rounded-md transition"
          >
            Back to Search
          </button>
        </div>
      </div>
    );
  }

  return <Loading />;
}


